const MAX_MULTISELECT_RESULT = 50;
const SHOW_ALL_MAX_RESULT = 1000;

export { MAX_MULTISELECT_RESULT, SHOW_ALL_MAX_RESULT };
